import React from 'react';

const AuthLayout =({children}) =>{
    return(
        <main className="cr-app bg-light">
            <div className='cr-content container-fluid'>
                {children}
            </div>
        </main>
    )
}
  
  export default AuthLayout;